export default __webpack_public_path__ + "static/media/SWT0090.34I-21362_-14902_0.12d839a1.jpg";